import React from 'react';
import './LetterTitle.css';

function LetterTitle() {
    return (
        <div className="title">
            {/* 편지 타이틀 */}
            <img src="/image/title-image.png" alt="Title Image" />
        </div>
    );
}

export default LetterTitle;
